(function(){
  'use strict';

  angular.module('eclipseApp.core').controller('ErrorTechnicalModalCtrl', ['$scope', '$modalInstance', 'data', function($scope, $modalInstance, data){
    $scope.title = 'Technical Error';
    $scope.message = 'I\'m sorry we encountered an issue while proccessing your request.';
    $scope.errorMsg = data.errorMsg;

    $scope.cancel = function(){
      $modalInstance.close();
    };
  }]);
})();
